<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <strong>配信テーマ一覧</strong>
          </CCardHeader>
          <CCardBody>
            <CButton
              color="success"
              class="ml-0 px-4"
              v-on:click="goETemplateCreate()"
            >
              <i class="icon cil-cloud-upload"></i>
              アップロード
            </CButton>

            <CDataTable
              class="my-3 table-outline bg-white"
              hover
              :items="tableItems"
              :fields="tableFields"
              column-filter
              sorter
              :items-per-page="10"
              size="sm"
              pagination
            >
              <td slot="name" class="text-left" slot-scope="{ item }">
                <strong>{{ item.name }}</strong>
              </td>
              <td slot="category" class="text-left" slot-scope="{ item }">
                <strong>{{ item.category }}</strong>
              </td>
              <td slot="fileName" class="text-left" slot-scope="{ item }">
                <strong>{{ item.fileName }}</strong>
              </td>
              <template #show_details="{ item }">
                <td class="py-2 text-center">
                  <CButton
                    size="sm"
                    class="px-3"
                    color="primary"
                    v-on:click="goTempalteEdit(item)"
                    >編集</CButton
                  >
                </td>
              </template>
            </CDataTable>
          </CCardBody>
          <CCardFooter> </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <!-- start_completeModal -->
  </div>
</template>

<script>
export default {
  name: "配信テンプレート",
  data() {
    return {
      tableItems: [
        {
          name: "Name One",
          category: "event",
          fileName: "template_file_one.txt",
        },
        {
          name: "Name two",
          category: "renovation",
          fileName: "template_file_two.txt",
        },
      ],
      tableFields: [
        { key: "name", label: "名", _classes: "text-left bg-light" },
        {
          key: "category",
          label: "カテゴリー",
          _classes: "text-left bg-light",
        },
        {
          key: "fileName",
          label: "フィウル名",
          _classes: "text-left bg-light",
        },
        {
          key: "show_details",
          _classes: " bg-light",
          label: "",
          _style: "width:10%",
          sorter: false,
          filter: false,
        },
      ],
    };
  },
  //入力項目にvalidation
  validations: {},
  beforeMount() {},
  methods: {
    goETemplateCreate() {
      this.$router.push({
        name: "配信テンプレート作成",
      });
    },
    goTempalteEdit() {
      this.$router.push({
        name: "テンプレート編集",
      });
    },
  },
};
</script>
